var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAif(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 18,
    width: 22,
    height: 36,
    fill: "#1A2A52"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 28,
    width: 16,
    height: 26,
    fill: "#4A5A82"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 23,
    width: 5,
    height: 5,
    fill: "#C9A227"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 23,
    width: 5,
    height: 5,
    fill: "#C9A227"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 32,
    width: 5,
    height: 5,
    fill: "#C9A227"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 32,
    width: 5,
    height: 5,
    fill: "#C9A227"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 41,
    width: 5,
    height: 5,
    fill: "#C9A227"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 41,
    width: 5,
    height: 5,
    fill: "#C9A227"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 33,
    width: 4,
    height: 4,
    fill: "#C9A227"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 33,
    width: 4,
    height: 4,
    fill: "#C9A227"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 41,
    width: 4,
    height: 4,
    fill: "#C9A227"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 41,
    width: 4,
    height: 4,
    fill: "#C9A227"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 54,
    width: 46,
    height: 3,
    fill: "#C9A227"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAif);
export default __webpack_public_path__ + "static/media/aif.4788e0a03f5eb00ae83523a4c282db54.svg";
export { ForwardRef as ReactComponent };